export const defaultAnimationOptions = {
  loop: false,
  autoplay: true,
  rendererSettings: {
    preserveAspectRatio: 'xMidYMid slice',
  },
  style: {
    width: '100%',
    height: '100%',
    overflow: 'hidden',
    margin: '0px auto',
    outline: 'none',
  },
};
